// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import { Alert } from "tailwindcss-stimulus-components"
application.register('alert', Alert)

import SlimSelectController from "./slim_select_controller";
application.register("slim-select", SlimSelectController);

import RailsNestedForm from '@stimulus-components/rails-nested-form'
application.register('nested-form', RailsNestedForm)